import { useState } from "react";
import { BioShell, ResultCard, primaryBtn, BIO_ACCENT } from "./BioShell.jsx";
import { translate, AMINO_NAMES, CODON_TABLE, round } from "./biocore.js";
import QuizMode from "../components/QuizMode.jsx";

export default function Translate() {
  const [seq, setSeq] = useState("ATGGCCATTGTAATGGGCCGCTGA");
  const [frame, setFrame] = useState(0);
  const [stopAt, setStopAt] = useState(true);
  const [res, setRes] = useState(null);
  const [quiz, setQuiz] = useState(false);

  // Curated recall over the standard genetic code already in this
  // tool. Prompt = codon, answer = amino acid (name + letter).
  const quizCards = Object.entries(CODON_TABLE).map(([codon, aa]) => ({
    q: codon,
    a: aa === "*" ? "Stop codon" : `${AMINO_NAMES[aa] || aa} (${aa})`,
    ctx: "Standard genetic code",
  }));

  const run = () => setRes(translate(seq, { frame, stopAtStop: stopAt }));

  return (
    <BioShell title="Codon Translator">
      {quiz ? (
        <QuizMode cards={quizCards} accent={BIO_ACCENT} onExit={() => setQuiz(false)} />
      ) : (
      <>
      <p style={{ fontSize: 13, color: "#5B5E7A", marginTop: 0 }}>
        Standard genetic code (NCBI table 1). DNA in, protein out.
      </p>
      <button
        onClick={() => setQuiz(true)}
        style={{ width: "100%", marginBottom: 14, padding: 12, borderRadius: 10, border: `1px solid ${BIO_ACCENT}`, background: BIO_ACCENT + "18", color: BIO_ACCENT, fontWeight: 700, fontSize: 14, cursor: "pointer" }}
      >
        Quiz me on the codon table →
      </button>
      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>DNA sequence</label>
      <textarea
        value={seq}
        onChange={(e) => setSeq(e.target.value)}
        rows={3}
        style={{ width: "100%", background: "#13141F", border: "1px solid #262839", borderRadius: 10, color: "#E8E9F3", fontSize: 14, padding: "12px 14px", boxSizing: "border-box", resize: "vertical", fontFamily: "ui-monospace, Menlo, monospace" }}
      />
      <div style={{ display: "flex", gap: 8, margin: "12px 0" }}>
        {[0, 1, 2].map((f) => (
          <button key={f} onClick={() => setFrame(f)} style={{ flex: 1, background: frame === f ? BIO_ACCENT : "#1C1E2E", color: frame === f ? "#04240F" : "#9A9DBE", border: "none", borderRadius: 8, padding: "9px 0", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
            Frame {f + 1}
          </button>
        ))}
      </div>
      <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, color: "#9A9DBE", marginBottom: 6 }}>
        <input type="checkbox" checked={stopAt} onChange={(e) => setStopAt(e.target.checked)} style={{ accentColor: BIO_ACCENT }} />
        Stop at first stop codon
      </label>
      <button onClick={run} style={primaryBtn}>Translate</button>
      {res && !res.ok && <ResultCard><span style={{ color: "#F8716A" }}>{res.error}</span></ResultCard>}
      {res && res.ok && (
        <ResultCard>
          <div style={{ fontSize: 12, color: "#9A9DBE", marginBottom: 6 }}>PROTEIN ({res.result.replace(/\*/g, "").length} aa, {res.codons} codons read)</div>
          <div style={{ fontFamily: "ui-monospace, Menlo, monospace", fontSize: 18, fontWeight: 700, color: BIO_ACCENT, wordBreak: "break-all", letterSpacing: 1 }}>
            {res.result || "(none)"}
          </div>
          {res.result && (
            <div style={{ marginTop: 14, fontSize: 13, color: "#9A9DBE", lineHeight: 1.7 }}>
              {res.result.split("").map((a, i) => (
                <span key={i} style={{ marginRight: 8, display: "inline-block" }}>
                  <b style={{ color: "#C8CADF" }}>{a}</b> {AMINO_NAMES[a]}
                </span>
              ))}
            </div>
          )}
        </ResultCard>
      )}
      </>
      )}
    </BioShell>
  );
}

